import styled from 'styled-components';
import { Text } from '@cuemath/comps';

export const PointerText = styled(Text)`
  cursor: pointer;
`;

export const CenterText = styled(Text)`
  text-align: center;
  font-weight: bold;
  padding: 8px 8px;
`;

export const CellText = styled(Text)`
  size: ${({ size }) => size || 'normal'};
  text-align: center;
`;
